import { defineMessages } from "react-intl";

export const staffAddMemberDialogMessages = defineMessages({
  title: {
    id: "23g7PY",
    defaultMessage: "Invite Staff Member",
    description: "dialog header",
  },
  description: {
    id: "ikKMd0",
    defaultMessage: "Send an invite and assign at least one permission group.",
    description: "dialog description",
  },
  sendInvite: {
    id: "hw9Fah",
    defaultMessage: "Send invite",
    description: "button",
  },
});
